import { Patient } from "src/modules/ktx/patient-list/types";

export function preCompareFn(a: Patient, b: Patient): number {
	if (a.status.value === "NEW" && b.status.value !== "NEW") {
		return -1;
	}
	if (b.status.value === "NEW" && a.status.value !== "NEW") {
		return 1;
	}
	return 0;
}
